module.exports = __webpack_public_path__ + "img/no-goods-img.5addca12.png";